import '.k{height:100%;}.ssr-plugin'
import '.bi{max-width:480px;}.ssr-plugin'
import '.es{margin-left:8px;}.ssr-plugin'
import '.et{margin-right:8px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.eu{max-height:calc(100vh - 192px);}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.ee{backdrop-filter:blur(48px);}.ssr-plugin'
import '.ef{-webkit-backdrop-filter:blur(48px);}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.ev{padding:20px 24px;}.ssr-plugin'
import '.ew{font-size:20px;}.ssr-plugin'
import '.ex{margin-top:4px;}.ssr-plugin'
import '.ey{overflow-y:scroll;}.ssr-plugin'
import '.ac{scrollbar-width:none;}.ssr-plugin'
import '.h{flex:1;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.cb{gap:16px;}.ssr-plugin'
import '.ah{height:1px;}.ssr-plugin'
import '.ez{margin:24px auto;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { getLanguageName } from '../utils/getLanguageName.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { MOBILE } from '../utils/breakpoints.js'
import { LANGUAGES } from '../../../schema/locales.js'
import { useVotingRegion } from '../hooks/useVotingRegion.js'
import { useDictionary } from '../hooks/useDictionary.js'

const allTheLanguages = Object.keys(LANGUAGES).sort((a, b) =>
  getLanguageName(a).localeCompare(getLanguageName(b)),
)

const POPULAR_LANGUAGES = ['en', 'de', 'fr']

export const SelectLanguageModal = ({ setModal }) => {
  const track = useTrack('menu')
  const [lang, setLanguage] = useLanguage()
  const [{ code }] = useVotingRegion()

  const { selectLanguage, recommended, allLanguages } = useDictionary()

  const regionalLanguages = lang.options.filter((code) => code !== 'en')
  const recommendedLanguages =
    code === 'ROW'
      ? ['en', 'de', 'fr']
      : [
          ...regionalLanguages,
          ...POPULAR_LANGUAGES.filter(
            (code) => !regionalLanguages.includes(code),
          ),
        ]

  return (
    <ModalWrapper onDismiss={() => setModal(false)}>
      <styled.div className="k bi es et m eu b1 cx e f ee ef"
        style={{
          backgroundColor: `${transparentColor(colors.secondary, 0.1)}`,
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            maxHeight: 'calc(100vh - 16px)',
            backgroundColor: `${transparentColor(colors.secondary, 0.8)}`,
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="e cv ao w ev"
          style={{
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          <h3 className="ew ex">
            {selectLanguage}
          </h3>
          <IconButton
            variant="ghost"
            id="language-modal-action-close-button"
            icon={<Icon type="closeIcon" />}
            onClick={() => setModal(false)}
          />
        </div>
        <styled.div className="ey ac h ev"
          style={{
            '& a': {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              userSelect: 'none',
              transition: 'all .2s ease-out',
              margin: '-8px -16px',
              padding: '8px 16px',
              borderRadius: '24px',
              border: '1px solid transparent',
              scale: '1',
              '&:hover': {
                background: `${colors.border}`,
                border: `1px solid ${colors.border}`,
                scale: '.98',
              },
            },
          }}
        >
          <p className="subtext bl bo"
          >
            {recommended}
          </p>

          <div className="e f cb"
          >
            {recommendedLanguages.map((item) => {
              return (
                <styled.a
                  key={item}
                  onClick={() => {
                    track(
                      AnalyticsEvent.MENU_LANG_CHANGE,
                      `${lang.code}->${item}`,
                    )
                    setLanguage(item)
                    setModal(false)
                  }}
                >
                  {getLanguageName(item)} <Icon type="chevronRightIcon" />
                </styled.a>
              )
            })}
          </div>

          <div className="ah m ez"
            style={{
              backgroundColor: colors.border,}}
          />

          <p className="subtext bl bo"
          >
            {allLanguages}
          </p>
          <div className="e f cb"
          >
            {allTheLanguages.map((item) => {
              return (
                <styled.a
                  id={`language-modal-action-set-language-${item}`}
                  key={item}
                  onClick={() => {
                    track(
                      AnalyticsEvent.MENU_LANG_CHANGE,
                      `${lang.code}->${item}`,
                    )
                    setLanguage(item)
                    setModal(false)
                  }}
                >
                  {getLanguageName(item)} <Icon type="chevronRightIcon" />
                </styled.a>
              )
            })}
          </div>
        </styled.div>
      </styled.div>
    </ModalWrapper>
  )
}
